const DEFAULT_MAX_ATTEMPTS = 10
const DEFAULT_DELAY_MS = 1500

export async function checkCampaignDownloadAccess({
  campaignId,
  syncUserCanDownloadCampaigns,
  getCampaignDownloadPurchased,
  onCampaignPurchased,
}) {
  if (await syncUserCanDownloadCampaigns()) {
    return true
  }

  if (!campaignId) {
    return false
  }

  const response = await getCampaignDownloadPurchased(campaignId)

  if (response?.data?.purchased) {
    onCampaignPurchased?.()
    return true
  }

  return false
}

export async function waitForCampaignDownloadAccess(
  options,
  {
    maxAttempts = DEFAULT_MAX_ATTEMPTS,
    delayMs = DEFAULT_DELAY_MS,
  } = {},
) {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (await checkCampaignDownloadAccess(options)) {
      return true
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => {
        setTimeout(resolve, delayMs)
      })
    }
  }

  return false
}
